
export default {
  name: 'AvatarCard',
  props: {
    avatar: {
      type: String,
      required: true,
    },
    backgroundColour: {
      type: String,
      required: false,
    },
  },
};
